import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';
/* import { ImpSectorActiEconomica } from './modalImpSectorActiEconomica';
import { ImpSectorActiEconomica2 } from './modalImpSectorActiEconomica2';
import { ImprimirPatente } from './modalImprimirPatente';
import { ActualizarLicencia } from './modalActualizarLicencia';*/
import { ConfiguracionModulo } from '../actividadEconomica/modalConfiguracionModulo';
import { ClasificadorApuestas } from './modalClasificadorApuestas';
import { ImpSectorApuesta } from './modalImprimirApuestas';



function MenuJuegos(props) {

    const { user, logout } = useContext(AuthContext);
    const pathname = window.location.pathname;

    const path = pathname === '/' ? 'login' : pathname.substr(1);
    const [activeItem, setActiveItem] = useState(path);
    const [permisos, setPermisos] = useState('');
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrar6, setMostrar6] = useState(false);
    const [mostrar7, setMostrar7] = useState(false);
    const [mostrarClasificador, setMostrarClasificador] = useState(false);
    const [mostrarEstados, setMostrarEstados] = useState(false);
    const [titulo1, setTitulo1] = useState();
    const [titulo2, setTitulo2] = useState();
    const [tipoRep, setTipoRep] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));


    let op = require('../../../../src/modulos/datos');

    useEffect(() => {

        setPermisos(JSON.parse(localStorage.getItem('permisos')));
        let obj = JSON.parse(localStorage.getItem('post'));
        setIdUsuario(obj.idusuario);
        //setEspiritu(obj.espiritu);
        /*setLiquidador(obj.liquidador);
        setLiquida(obj.liquida);*/
        setFechaSistema(obj.fechasistema);
        setEspiritu(obj.espiritu);

    }, [props.permisos]);


    const handleItemClick = (e, { name }) => setActiveItem(name);

    const imprimirListadoAgente = () => {
        window.location.href = '/actividadEconomica';
        var reporte = 'ListGenComercioAgente';
        window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const imprimirListadoCredito = () => {
        window.location.href = '/actividadEconomica';
        var reporte = 'ListGenComercioCredito';
        window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const handleCancelaImpSector = () => {
        /* window.location.href = '/JuegosApuestas'; */
        setMostrar3(false);

    }

    const handleCancelaImpPatente = () => {
        //window.location.href = '/actividadEconomica';
        setMostrar6(false);

    }

    const handleCancelaImpSector2 = () => {
        //window.location.href = '/actividadEconomica';
        setMostrar4(false);

    }






    const handleCancelaRenovacionLic = () => {
        window.location.href = '/actividadEconomica';
        setMostrar5(false);

    }

    const handleCancelaSolicitudLic = () => {
        window.location.href = '/actividadEconomica';
        setMostrar6(false);

    }

    const handleImpSector = (tiprep) => (event) => {
        setTipoRep(tiprep)

        if (tiprep === '1') {
            setTitulo1('ImpresionGeneral de Contribuyentes Apuestas Licitas por Sector');
            setTitulo2('Listado General de Contribuyentes Por Sector');
        }

        else if (tiprep === '2') {
            setTitulo1('Declarraciones Anuales de Contribuyentes Apuestas Licitas');
            setTitulo2('Declaraciones Anuales de Contribuyentes Apuestas Licitas');
        }

        else if (tiprep === '3') {
            setTitulo1('Impresión Gneral de Contribuyentes Apuestas Licitas con Deudas');
            setTitulo2('Listado Contribuyentes con Deudas');
        }

        setMostrar3(true)
    }

    const handleImpSector2 = (tiprep) => (event) => {
        setTipoRep(tiprep)
        if (tiprep === '1') {
            setTitulo1('Tipos de Rentas Municipales');
            setTitulo2('Tipos de Rentas Municipales');
        }
        setMostrar4(true)
    }

    const clasificador = () => {

        setMostrarClasificador(true)
    }

    const CerrarClasificador = () => {

        setMostrarClasificador(false);

    }

    const estado = () => (event) => {
        setMostrarEstados(true)
    }

    const CerrarEstado = () => {

        setMostrarEstados(false);

    }


    const handleImpPatente = () => (event) => {
        setMostrar7(true)
    }

    const handleRenovacionLic = () => {
        setMostrar5(true)
    }

    const handleSolicitudLic = () => {
        setMostrar6(true)
    }

    const abrirConfiModulo = () => {
        setMostrar7(true)
    }

    const handleCancelaConfi = () => {
        setMostrar7(false)
    }

    const menu =  ''


    return menu;

} export default MenuJuegos;